import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RetrievePaymentReportInput, RetrievePaymentRequestInput, RetrieveFuturePaymentReportInput, RetrievePaymentReportInput_extend } from '../models/clinicParms/payment_profile_request';

@Injectable({
  providedIn: 'root'
})
export class PaymentHistoryService {
  private API_URL = environment.API_URL;
  constructor(private fb: FormBuilder, private http: HttpClient) { }

  GetPaymentHistoryByPatient(request: RetrievePaymentRequestInput) {
    var payload = {
      "patientID": request.patientID,
      "profileid": !request.profileId ? null : request.profileId,
      "branchId": request.branchId
    };
    return this.http.post(this.API_URL + 'CardPay/GetPatientPayments', payload).
      pipe(
        map((data: any) => {
          // console.log("GetPaymentHistoryByPatient", data);
          return data;
        }), catchError(error => {
          return throwError('Get Payment history failed, Something went wrong!');
        })
      );
  }
  GetPaymentHistoryByPatient2(request: RetrievePaymentRequestInput) {
    var payload = {
      "patientID": request.patientID,
      "profileid": !request.profileId ? null : request.profileId,
      "branchId": request.branchId
    };
    return this.http.post(this.API_URL + 'CardPay/GetPatientPayments2', payload).
      pipe(
        map((data: any) => {
          // console.log("GetPaymentHistoryByPatient", data);
          return data;
        }), catchError(error => {
          return throwError('Get Payment history failed, Something went wrong!');
        })
      );
  }
  GetPaymentHistoryByPatient_extend(request: RetrievePaymentRequestInput) {
    var payload = {
      "patientID" : request.patientID,
      "profileid" : !request.profileId? null : request.profileId,
      "branchId" : request.branchId
    };
    return this.http.post(this.API_URL + 'CardPay/GetPatientPayments_Extend', payload).
      pipe(
        map((data: any) => {
          console.log("GetPaymentHistoryByPatient", data);
          return data;
        }), catchError( error => {
          return throwError('Get Payment history failed, Something went wrong!');
        })
    );
  }

  GetPaymentHistory(request: RetrievePaymentReportInput) {
    if (request.subscriptionId == -1) {
      request.subscriptionId = null;
    }
    var payload = {
      "fromDate": request.fromDate,
      "toDate": request.toDate,
      "branchId": request.branchId,
      "patientID": request.patientId,
      "invoiceId": request.invoiceId,
      "retref": request.referenceId,
      "subscriptionId": request.subscriptionId,
    };
    return this.http.post(this.API_URL + 'CardPay/GetAllPayments', payload).
      pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          return throwError('Get Payment history failed, Something went wrong!');
        })
      );
  }
  GetPaymentHistoryReport(request: RetrievePaymentReportInput) {    
    var payload = {
      "fromDate" : request.fromDate,
      "toDate" : request.toDate,
      "branchId" : request.branchId,
      "patientID": request.patientId,
      "invoiceId": request.invoiceId,
      "retref": request.referenceId,
      "subscriptionId": request.subscriptionId,
    };
    return this.http.post(this.API_URL + 'CardPay/GetAllPaymentsReports', payload).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get Payment history failed, Something went wrong!');
        })
    );
  }
  GetOrderReport(request: RetrievePaymentReportInput) {    
    if(request.subscriptionId <= 0){
      request.subscriptionId = null;
    }
    var payload = {
      "fromDate" : request.fromDate,
      "toDate" : request.toDate,
      "branchId" : request.branchId,
      "patientID": request.patientId,
      "invoiceId": request.invoiceId,
      "retref": request.referenceId,
      "subscriptionId": request.subscriptionId,
    };
    return this.http.post(this.API_URL + 'CardPay/GetAllPayments', payload).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get Payment history failed, Something went wrong!');
        })
    );
  }
  //For paginated report
  GetPaymentHistoryReport_extend(request: RetrievePaymentReportInput_extend) {    
    var payload = {
      "fromDate" : request.fromDate,
      "toDate" : request.toDate,
      "branchId" : request.branchId
    };

    // Build query parameters for pagination
    let queryParams = new URLSearchParams();
    if (request.pageSize) queryParams.set('pageSize', request.pageSize.toString());
    if (request.afterInvoiceDate) queryParams.set('afterInvoiceDate', request.afterInvoiceDate);
    if (request.afterInvoiceId) queryParams.set('afterInvoiceId', request.afterInvoiceId.toString());
    if (request.beforeInvoiceDate) queryParams.set('beforeInvoiceDate', request.beforeInvoiceDate);
    if (request.beforeInvoiceId) queryParams.set('beforeInvoiceId', request.beforeInvoiceId.toString());
    if (request.exportAll !== undefined) queryParams.set('exportAll', request.exportAll.toString());

    const url = this.API_URL + 'CardPay/GetAllPaymentsReports_Extend' + 
                (queryParams.toString() ? '?' + queryParams.toString() : '');
    return this.http.post(url, payload).
      pipe(
        map((data: any) => {
          if (data) {
            Object.keys(data).forEach(key => {
              if (key.toLowerCase().includes('cursor') || 
                  key.toLowerCase().includes('invoice') || 
                  key.toLowerCase().includes('date') || 
                  key.toLowerCase().includes('id')) {
              }
            });
          }
          console.log("GetPaymentHistoryReport data:", data);
          
          // Check if data is wrapped in a response object
          let actualData = data;
          if (data && data.data && typeof data.data === 'object') {
            console.log("Data is wrapped, using data.data");
            actualData = data.data;
          }
          
          // Handle the specific paginated response structure
          if (actualData && Array.isArray(actualData.items)) {
            // Construct cursor objects from the API response
            // The API returns nextCursor and prevCursor as objects with lastInvoiceDate/lastInvoiceId and firstInvoiceDate/firstInvoiceId
            const nextCursor = actualData.nextCursor && actualData.nextCursor.lastInvoiceDate && actualData.nextCursor.lastInvoiceId ? {
              afterInvoiceDate: actualData.nextCursor.lastInvoiceDate,
              afterInvoiceId: actualData.nextCursor.lastInvoiceId
            } : null;
            
            const prevCursor = actualData.prevCursor && actualData.prevCursor.firstInvoiceDate && actualData.prevCursor.firstInvoiceId ? {
              beforeInvoiceDate: actualData.prevCursor.firstInvoiceDate,
              beforeInvoiceId: actualData.prevCursor.firstInvoiceId
            } : null;
            
            console.log("Constructed cursors - nextCursor:", nextCursor, "prevCursor:", prevCursor);
            
            return {
              items: actualData.items,
              totalCount: actualData.totalCount || 0,
              nextCursor: nextCursor,
              prevCursor: prevCursor
            };
          } else if (actualData && actualData.totalCount && Array.isArray(actualData.items)) {
            // Handle case where items might be nested differently
            console.log("Handling nested items structure");
            const nextCursor = actualData.nextCursor && actualData.nextCursor.lastInvoiceDate && actualData.nextCursor.lastInvoiceId ? {
              afterInvoiceDate: actualData.nextCursor.lastInvoiceDate,
              afterInvoiceId: actualData.nextCursor.lastInvoiceId
            } : null;
            
            const prevCursor = actualData.prevCursor && actualData.prevCursor.firstInvoiceDate && actualData.prevCursor.firstInvoiceId ? {
              beforeInvoiceDate: actualData.prevCursor.firstInvoiceDate,
              beforeInvoiceId: actualData.prevCursor.firstInvoiceId
            } : null;
            
            console.log("Constructed cursors (nested) - nextCursor:", nextCursor, "prevCursor:", prevCursor);
            
            return {
              items: actualData.items,
              totalCount: actualData.totalCount || 0,
              nextCursor: nextCursor,
              prevCursor: prevCursor
            };
          } else if (Array.isArray(actualData)) {
            // Fallback for direct array response
            return {
              items: actualData,
              totalCount: actualData.length,
              nextCursor: null,
              prevCursor: null
            };
          } else if (actualData && actualData.totalCount) {
            // Handle case where data is the response object directly
            console.log("Handling direct response object structure");
            const items = actualData.items || actualData.data || [];
            const nextCursor = actualData.lastInvoiceDate && actualData.lastInvoiceId ? {
              afterInvoiceDate: actualData.lastInvoiceDate,
              afterInvoiceId: actualData.lastInvoiceId
            } : null;
            
            const prevCursor = actualData.firstInvoiceDate && actualData.firstInvoiceId ? {
              beforeInvoiceDate: actualData.firstInvoiceDate,
              beforeInvoiceId: actualData.firstInvoiceId
            } : null;
            
            console.log("Constructed cursors (direct) - nextCursor:", nextCursor, "prevCursor:", prevCursor);
            
            return {
              items: items,
              totalCount: actualData.totalCount || 0,
              nextCursor: nextCursor,
              prevCursor: prevCursor
            };
          } else {
            console.warn("Unexpected API response structure:", data);
            return {
              items: [],
              totalCount: 0,
              nextCursor: null,
              prevCursor: null
            };
          }
        }), catchError( error => {
          console.error("GetPaymentHistoryReport error:", error);
          return throwError('Get Payment history failed, Something went wrong!');
        })
    );
  }
  GetPaymentHistoryReport_ForExporting(request: RetrievePaymentReportInput_extend) {    
    var payload = {
      "fromDate" : request.fromDate,
      "toDate" : request.toDate,
      "branchId" : request.branchId
    };

    // Build query parameters for maxRows (default 100000 as shown in API docs)
    let queryParams = new URLSearchParams();
    queryParams.set('maxRows', '100000'); // Set max rows to get all records

    const url = this.API_URL + 'CardPay/GetAllPaymentsReports_ExportAll' + 
                (queryParams.toString() ? '?' + queryParams.toString() : '');
    console.log("GetPaymentHistoryReport_ForExporting URL:", url);
    console.log("GetPaymentHistoryReport_ForExporting payload:", payload);
    
    return this.http.post(url, payload).
      pipe(
        map((data: any) => {
          console.log("=== EXPORT API RESPONSE ===");
          console.log("GetPaymentHistoryReport_ForExporting API Response:", data);
          console.log("API Response type:", typeof data);
          console.log("API Response keys:", Object.keys(data || {}));
          console.log("Is Array:", Array.isArray(data));
          console.log("=== END EXPORT API RESPONSE ===");
          
          // The export API should return all records directly as an array
          if (Array.isArray(data)) {
            console.log(`Export API returned ${data.length} records`);
            return data;
          } else if (data && Array.isArray(data.data)) {
            console.log(`Export API returned ${data.data.length} records in data property`);
            return data.data;
          } else if (data && Array.isArray(data.items)) {
            console.log(`Export API returned ${data.items.length} records in items property`);
            return data.items;
          } else {
            console.warn("Unexpected export API response structure:", data);
            return [];
          }
        }), catchError( error => {
          console.error("GetPaymentHistoryReport_ForExporting error:", error);
          return throwError('Get Payment history for export failed, Something went wrong!');
        })
    );
  }
  GetFuturePayments(request: RetrieveFuturePaymentReportInput) {
    return this.http.post(this.API_URL + 'ClinicSubscription/GetPendingSubscriptionPayments', request).
      pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          if (error.status === 404) {
            return of([]);  // no pending payments found � treat as empty list
          }
          return throwError('Get Future Payment failed, Something went wrong!');
        })
      );
  }
  GetInvoiceWithDetails(invoiceId: number) {
    // Build query parameters
    let queryParams = new URLSearchParams();
    queryParams.set('invoiceId', invoiceId.toString());

    const url = this.API_URL + 'CardPay/GetInvoiceWithDetails' + 
                (queryParams.toString() ? '?' + queryParams.toString() : '');
    
    console.log("GetInvoiceWithDetails URL:", url);
    console.log("GetInvoiceWithDetails invoiceId:", invoiceId);
    
    return this.http.post(url, {}). // Empty body since it's a POST with query params
      pipe(
        map((data: any) => {
          console.log("GetInvoiceWithDetails API Response:", data);
          return data;
        }), 
        catchError(error => {
          console.error("GetInvoiceWithDetails error:", error);
          return throwError('Get Invoice Details failed, Something went wrong!');
        })
    );
  }
}
